import React from "react";
import { SingleVesselProvider } from "./state/singleVesselContext";
import SingleVesselView from "./components/SingleVesselView";

export default function SingleVesselCalcy(props) {
  return (
    <SingleVesselProvider>
      <SingleVesselView {...props} />
    </SingleVesselProvider>
  );
}